import { api } from './client';

/**
 * POST /phone-verification/initiate {phone} (+ X-Venue-Slug от клиента ядра): Plusofon звонит на
 * номер, код — последние 4 цифры звонящего номера. Сам код подтверждает вызывающий маршрут
 * (PUT /users/me/phone или POST /auth/telegram/link). Тихо: ошибки показывает форма номера.
 */
export async function initiatePhoneCall(phone: string): Promise<void> {
  await api.post<{ callId?: string }>('/phone-verification/initiate', { phone }, { silent: true });
}
